import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Store } from "@viewer/core";
import {
  MultiLinkMeta,
  TocInfoWithAnchor
} from "@viewer/shared-module/multilinks/multilinks.service";
import { OrionCardSource } from "@viewer/shared-module/orion-card/pipe/orion-card.pipe";

@Component({
  standalone: false,
  selector: "o-multilinks",
  templateUrl: "./multilinks.component.html",
  styleUrls: ["./multilinks.component.scss"]
})
export class MultilinksComponent implements OnInit {
  public readonly orionCardSource = OrionCardSource;
  public links: TocInfoWithAnchor[] = [];

  constructor(
    public dialogRef: MatDialogRef<MultilinksComponent>,
    public store: Store,
    @Inject(MAT_DIALOG_DATA) public data: Pick<MultiLinkMeta, "links">
  ) {}

  ngOnInit() {
    this.links = this.data.links;
  }

  public close() {
    this.dialogRef.close();
  }
}
